<div [ngClass]="[headerClasses]" routerLinkActive="active">
  <div>
    <app-back-button (click)="back($event)"></app-back-button>
  </div>
  <div>
    <app-menu></app-menu>
  </div>
</div>
